import { FlashcardsApp } from "src/components/NewComponents/Flashcards/App/FlashcardsApp";

export default function FlashcardsAppContainer() {
	return <FlashcardsApp />;
}
